module.exports = __webpack_public_path__ + "static/media/b0_p8_clickable_ph.2cfe37f6.png";